const calendarMenuItems = [
    {
        enabled: true,
        key: "calendar",

        label: "Takvim",
        icon: {
            type: "material-icons",
            name: "calendar_today",
        },
    },
    {
        enabled: true,
        key: "reservationBuilder",
        label: "Rezervasyon Websitesi",
        icon: {
            type: "material-icons",
            name: "web",
        },
    },
    {
        enabled: true,
        key: "events",
        path: "/calendar/events",

        label: "Etkinlikler",
        icon: {
            type: "material-icons",
            name: "event",
        },
    },
    {
        enabled: true,
        key: "reservations",
        path: "/calendar/reservations",
        label: "Rezervasyonlar",
        icon: {
            type: "material-icons",
            name: "book_online",
        },
    },
    {
        enabled: true,
        key: "reservationPrograms",
        path: "/reservation/programs",
        label: "Rezervasyon Programları",
        icon: {
            type: "material-icons",
            name: "event_note",
        },
    },
];
export default calendarMenuItems;
